import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import MeasurementOverview from './MeasurementOverview.js';
import MeasurementPVLayout from './MeasurementPVLayout.js';
import MeasurementInverters from './MeasurementInverters.js';
import MeasurementMetering from './MeasurementMetering.js';
import MeasurementPerformance from './MeasurementPerformance.js';
import MeasurementIndicator from './MeasurementIndicator.js';
import MeasurementEnvironment from './MeasurementEnvironment.js';

import Minibar from '../../../components/navbar/Minibar';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import './Measurement.css';

function Measurement(props) {
    const location = useLocation();
    const [data_uioption, setData_uioption] = useState({});
    const [data_status_indicator, setData_status_indicator] = useState({})
    const [data_status_common, setData_status_common] = useState({})
    const [data_environment, setData_environment] = useState({})
    const [data_inverter, setData_inverter] = useState([])
    const [data_metergrid, setData_metergrid] = useState({})
    const [data_metersolar, setData_metersolar] = useState([])
    const [data_metersolar_total, setData_metersolar_total] = useState({})
    const [data_calculation, setData_calculation] = useState({})

    const [modal_pr30d, setModal_pr30d] = useState(false);
    const [modal_sampling, setModal_sampling] = useState(false);
    const [submenu_root, setSubmenu_root] = useState('-');
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    useEffect(() => {
        return () => {
            setData_status_indicator({})
            setData_status_common({})
            setData_uioption({})
            setData_environment({})
            setData_inverter([])
            setData_metergrid({})
            setData_metersolar([])
            setData_metersolar_total({})
            setData_calculation({})
        };
    }, []);

    useEffect(() => {
        if (location.pathname.search("/measurement/overview") > -1) {
            setSubmenu_root('Overview')
        }
        if (location.pathname.search("/measurement/pvlaout") > -1) {
            setSubmenu_root('PV Layout')
        }
        if (location.pathname.search("/measurement/inverters") > -1) {
            setSubmenu_root('Inverters')
        }
        if (location.pathname.search("/measurement/systemperformance") > -1) {
            setSubmenu_root('System Performance')
        }
        if (location.pathname.search("/measurement/indicator") > -1) {
            setSubmenu_root('Status Indicator')
        }
        if (location.pathname.search("/measurement/metering") > -1) {
            setSubmenu_root('Metering')
        }
        if (location.pathname.search("/measurement/environment") > -1) {
            setSubmenu_root('Environment')
        }
    }, [location]);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            setData_uioption(props.data_uioption)
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_environment !== null && props.data_environment !== undefined) {
            setData_environment(props.data_environment)
        }
    }, [props.data_environment]);

    useEffect(() => {
        if (props.data_inverter !== null && props.data_inverter !== undefined) {
            setData_inverter(props.data_inverter)
        }
    }, [props.data_inverter]);

    useEffect(() => {
        if (props.data_metergrid !== null && props.data_metergrid !== undefined) {
            setData_metergrid(props.data_metergrid)
        }
    }, [props.data_metergrid]);

    useEffect(() => {
        if (props.data_metersolar !== null && props.data_metersolar !== undefined) {
            setData_metersolar(props.data_metersolar)
        }
    }, [props.data_metersolar]);

    useEffect(() => {
        if (props.data_metersolar_total !== null && props.data_metersolar_total !== undefined) {
            setData_metersolar_total(props.data_metersolar_total)
        }
    }, [props.data_metersolar_total]);

    useEffect(() => {
        if (props.data_calculation !== null && props.data_calculation !== undefined) {
            setData_calculation(props.data_calculation)
        }
    }, [props.data_calculation]);

    useEffect(() => {
        if (props.data_status_indicator !== null && props.data_status_indicator !== undefined) {
            setData_status_indicator(props.data_status_indicator)
        }
    }, [props.data_status_indicator]);

    useEffect(() => {
        if (props.data_status_common !== null && props.data_status_common !== undefined) {
            setData_status_common(props.data_status_common)
        }
    }, [props.data_status_common]);

    function ReadDatatags(tagobject, tagname, digit, ispercent) {
        const value = tagobject?.[tagname];
        if (value === undefined || value === null) {
            return "-"
        }

        if (ispercent !== undefined) {
            if (ispercent === true && value >= 100) {
                return "100"
            }
            return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    function ReadDatatagsPowerProduction(tagobject, tagname, digit) {
        const value = tagobject?.["summary_energy"]?.[tagname];
        if (value === undefined || value === null) {
            return "-"
        }

        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    function ReadDatatagsPowerDC(tagobject, tagname, digit) {
        const value = tagobject?.["summary_dc"]?.[tagname];
        if (value === undefined || value === null) {
            return "-"
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    function ReadDatatagsEnsToday(tagobject, tagname, digit) {
        const value = tagobject?.["summary_ens"]?.[tagname];
        if (value === undefined || value === null) {
            return "-"
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    function getDeviceStatusDirect(data) {
        const value = data?.connection_device;
        if (value === undefined || value === null) {
            return <span className='tagalarm'>...</span>
        }

        if (data.connection_device === true) {
            return null
        }
        return <span className='tagalarm alarming'>Device Offline</span>
    }

    function getDeviceStatus(data) {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <span className='tagalarm'>...</span>
        }

        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                return null
            }
            return <span className='tagalarm alarming'>Device Offline</span>
        }
        return <span className='tagalarm alarming'>Logger Offline</span>
    }

    function getIRRErrorStatus(data) {
        const value = data?.error_irr;
        if (value === undefined || value === null) {
            return <span className='tagalarm'>...</span>
        }

        if (data.error_irr === false) {
            return null
        }
        return <span className='tagalarm alarming'>Error</span>
    }

    function getENSError_Color(data, good_color) {
        const value = data?.error_ens;
        if (value === undefined || value === null) {
            return ""
        }

        if (data.error_ens === false) {
            return good_color
        }
        return "color-red"
    }

    function getSolarError_Color(data, good_color) {
        const value = data?.error_solar;
        if (value === undefined || value === null) {
            return ""
        }

        if (data.error_solar === false) {
            return good_color
        }
        return "color-red"
    }

    function getPRError_Color(data) {
        const value = data?.error_pr;
        if (value === undefined || value === null) {
            return ""
        }

        if (data.error_pr === false) {
            return "color-green"
        }
        return "color-red"
    }


    function getTagString(data, tag) {
        const value = data?.[tag];
        if (value === undefined || value === null) {
            return ""
        }
        return data[tag]
    }

    function getPR30DBlock(data) {
        const value = data?.pr30d;
        if (value === undefined || value === null) {
            return null
        }

        return <div className="measure-side-rows pr30d-block" onClick={() => { setModal_pr30d(true) }}>
            <div className="measure-side-cell">% PR 30 Days</div>
            <div className="measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px ">{ReadDatatags(data_calculation, 'pr30d', 2, true)}</div>
        </div>
    }

    function draw_solar_meter_total(meter_solar, meter_solar_total) {
        const value = meter_solar;
        if (value === undefined || value === null) {
            return null
        }
        if (meter_solar_total === undefined || meter_solar_total === null) {
            return null
        }
        if (meter_solar.length < 2) {
            return null
        }

        return <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12" key={'MeterSolar-' + meter_solar_total.meter_id_text}>
            <div>
                <hr className="mt-1 mb-2" />
                <h6 className="mb-0">{meter_solar_total.meter_id_text} {meter_solar_total.connection_device === false ? <span className='tagalarm alarming'>Device Offline</span> : null}</h6>
                <div className="measure-side-table">
                    <div className="measure-side-rows">
                        <div className="measure-side-cell">P</div>
                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_active_total', 2)}</div>
                        <div className="measure-side-cell measure-side-cell-unit">kW</div>
                    </div>
                    <div className="measure-side-rows">
                        <div className="measure-side-cell">S</div>
                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_apparent_total', 2)}</div>
                        <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                    </div>
                    <div className="measure-side-rows">
                        <div className="measure-side-cell">V</div>
                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'voltage', 2)}</div>
                        <div className="measure-side-cell measure-side-cell-unit">V</div>
                    </div>
                    <div className="measure-side-rows">
                        <div className="measure-side-cell">I</div>
                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'current_total', 2)}</div>
                        <div className="measure-side-cell measure-side-cell-unit">A</div>
                    </div>
                    <div className="measure-side-rows">
                        <div className="measure-side-cell">PF</div>
                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_factor', 2)}</div>
                        <div className="measure-side-cell measure-side-cell-unit"></div>
                    </div>
                </div>
            </div>
        </div>
    }


    function getSamplingState(tagobject, tagname, index) {
        const value = tagobject?.[tagname]?.[index]?.state;
        if (value === undefined || value === null) {
            return ""
        }
        if (tagobject[tagname][index].state === 1) {
            return "alarmevent-bg-green"
        } else if (tagobject[tagname][index].state === 2) {
            return "alarmevent-bg-red"
        } else if (tagobject[tagname][index].state === 3) {
            return "alarmevent-bg-orange"
        } else {
            return ""
        }
    }

    function readsampling_value(tag, index, subtag, digits) {
        const value = tag?.irr_sampling?.[index]?.state;
        if (value === undefined || value === null) {
            return ""
        }

        if (tag.irr_sampling[index].state === 0) {
            return "-"
        } else {
            return tag.irr_sampling?.[index]?.[subtag]?.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
        }
    }

    function readsampling_timestamp(tag, index, subtag) {
        const value = tag?.irr_sampling?.[index]?.state;
        if (value === undefined || value === null) {
            return null
        }

        if (tag.irr_sampling[index].state === 0) {
            return <div className="measure-side-cell">-</div>
        } else if (tag.irr_sampling[index].state === 1) {
            return <div className="measure-side-cell alarmevent-text-green">{tag.irr_sampling[index][subtag]}</div>
        } else if (tag.irr_sampling[index].state === 2) {
            return <div className="measure-side-cell alarmevent-text-red">{tag.irr_sampling[index][subtag]}</div>
        } else if (tag.irr_sampling[index].state === 3) {
            return <div className="measure-side-cell alarmevent-text-red">{tag.irr_sampling[index][subtag]}</div>
        }
    }

    function check_irr2() {
        const value = data_uioption?.has_irr2;
        if (value === undefined || value === null) {
            return ' d-none'
        }

        if (data_uioption.has_irr2 === true) {
            return ' '
        }
        return ' d-none'
    }

    function check_irr_sample_color(tag, index, name) {
        const value = data_uioption?.has_irr2;
        if (value === undefined || value === null) {
            return ' d-none'
        }

        if ((data_uioption.has_irr2 === true && name === "state_irr2") || name === "state_irr1") {
            if (tag !== null && tag !== undefined) {
                if (tag.irr_sampling !== null && tag.irr_sampling !== undefined) {
                    if (tag.irr_sampling[index][name] === 0) {
                        return ""
                    } else if (tag.irr_sampling[index][name] === 1) {
                        return ""
                    } else {
                        return " alarmevent-text-red"
                    }
                }
                return " "
            }
            return " "
        }
        return ' d-none'
    }

    function ReadTags_SensorAlert(data, con_tag, alert_tag) {
        const value1 = data?.[alert_tag];
        if (value1 === undefined || value1 === null) {
            return ""
        }
        const value2 = data?.[con_tag];
        if (value2 === undefined || value2 === null) {
            return ""
        }
        if (data.connection_logger === true && data.connection_device === true) {
            if (data[con_tag]["connection_logger"] === true && data[con_tag]["connection_device"] === true) {
                if (data[alert_tag] === true) {
                    return " alarmevent-text-red"
                } else {
                    return ""
                }
            } else {
                return " alarmevent-text-red"
            }
        } else {
            return " alarmevent-text-red"
        }
    }

    function get_panel_area() {
        const value = data_uioption?.factor_area;
        if (value === undefined || value === null) {
            return "-"
        }
        return value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }

    function get_site_capacity() {
        const value = data_uioption?.capacity;
        if (value === undefined || value === null) {
            return "-"
        }
        return value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }

    function getCT_Alert(meter) {
        const value = meter?.connection_device;
        if (value === undefined || value === null) {
            return null
        }
        if (meter.connection_device === true && meter.ct_alert === false) {
            return <span className='tagalarm alarming'>CT</span>
        }
        return null
    }


    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Measurement"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <aside className="w-md-250px content__wrap flex-shrink-0 pe-0 order-1 border-right d-none d-md-block">
                    <div className='d-flex justify-content-between pe-2 align-middle'>
                        <h4>Capacity</h4>
                        <h4 className='font-sarabun'>{get_site_capacity()} kWp</h4>
                    </div>
                    <div className='d-flex justify-content-between pe-2 align-middle'>
                        <h6>Total Panel Area {get_panel_area()} m<sup>2</sup></h6>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <hr className="mt-1 mb-2" />
                            <h5 className="mb-0"><i className="fas fa-bolt mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Production Summary</h5>
                            <div className="measure-side-table production">
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">Today</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600 " + getSolarError_Color(data_calculation, "")}>{ReadDatatagsPowerProduction(data_calculation, 'today', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">kWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">This Month</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'thismonth', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">This Year</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'thisyear', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">Total</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'total', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">ENS Today</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600 " + getENSError_Color(data_calculation, "")}>{ReadDatatagsEnsToday(data_calculation, 'today', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">kWh</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <hr className="mt-1 mb-2" />
                            <h5 className="mb-0">System Ratio {getIRRErrorStatus(data_calculation)}</h5>
                            <div className="measure-side-table production">
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">% OR</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px " + getPRError_Color(data_calculation)}>{ReadDatatags(data_calculation, 'operation_ratio', 2, true)}</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">% PR</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px " + getPRError_Color(data_calculation)}>{ReadDatatags(data_calculation, 'performance_ratio', 2, true)}</div>
                                </div>
                                {
                                    getPR30DBlock(data_calculation)
                                }
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <hr className="mt-1 mb-2" />
                            <h5 className="mb-0">DC Energy</h5>
                            <div className="measure-side-table production">
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">Today</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerDC(data_calculation, 'today', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">kWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">This Month</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerDC(data_calculation, 'thismonth', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">This Year</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 600">{ReadDatatagsPowerDC(data_calculation, 'thisyear', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">Total</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerDC(data_calculation, 'total', 3)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <hr className="mt-1 mb-2" />
                            <h6 className="mb-0">Environment {getDeviceStatus(data_environment)}</h6>
                            <div className='env-sampling-indicator' onClick={() => { setModal_sampling(true) }}>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 0))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 1))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 2))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 3))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 4))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 5))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 6))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 7))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 8))}></div>
                                <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 9))}></div>
                            </div>
                            <div className="measure-side-table">
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> {getTagString(data_environment, 'irr1_name')}</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_irr1", 'sensor_alert_irr1')}>{ReadDatatags(data_environment, 'total_irr1', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                </div>
                                {
                                    data_uioption.has_irr2 ?
                                        data_uioption.has_irr2 === true ?
                                            <div className="measure-side-rows">
                                                <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> {getTagString(data_environment, 'irr2_name')}</div>
                                                <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_irr2", 'sensor_alert_irr2')}>{ReadDatatags(data_environment, 'total_irr2', 2)}</div>
                                                <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                            </div>
                                            :
                                            null
                                        :
                                        null
                                }
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> IRR AVG.</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_environment, 'irr_avg_total', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-thermometer mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Amb. Temp.</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_ambient_rh", 'sensor_alert_temp_ambient')}>{ReadDatatags(data_environment, 'ambient_temp', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Panel Temp.</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_temp_pv", 'sensor_alert_temp_pv')}>{ReadDatatags(data_environment, 'pv_temp', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Tray Temp.</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_temp_tray", 'sensor_alert_temp_tray')}>{ReadDatatags(data_environment, 'custom1_tempraceway', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> R.Humidity</div>
                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_ambient_rh", 'sensor_alert_humidity')}>{ReadDatatags(data_environment, 'custom2_rh', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">%RH</div>
                                </div>
                                {
                                    data_uioption.has_windspeed ?
                                        data_uioption.has_windspeed === true ?
                                            <>
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell"><i className="mdi mdi-windsock mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Wind Speed</div>
                                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_windsensor", 'sensor_alert_wind_speed')}>{ReadDatatags(data_environment, 'windspeed', 2)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit">m/sec.</div>
                                                </div>
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell"><i className="mdi mdi-compass mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Wind Direction</div>
                                                    <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_windsensor", 'sensor_alert_wind_direction')}>{ReadDatatags(data_environment, 'winddirection', 0)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit">°</div>
                                                </div>
                                            </>
                                            :
                                            null
                                        :
                                        null
                                }
                                {
                                    data_uioption.has_waterlevel ?
                                        data_uioption.has_waterlevel === true ?
                                            <div className="measure-side-rows">
                                                <div className="measure-side-cell"><i className="mdi mdi-waves mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Water Level</div>
                                                <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_waterlevel", 'sensor_alert_water_level')}>{ReadDatatags(data_environment, 'waterlevel', 2)}</div>
                                                <div className="measure-side-cell measure-side-cell-unit">m.</div>
                                            </div>
                                            :
                                            null
                                        :
                                        null
                                }
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <hr className="mt-1 mb-2" />
                            <h6 className="mb-0">Grid Meter {getDeviceStatus(data_metergrid)}</h6>
                            {
                                data_metergrid ?
                                    <h6 className="mb-0 h6">S/N: {data_metergrid.serial_no}</h6>
                                    :
                                    <h6 className="mb-0 h6">S/N: -</h6>
                            }
                            <div className="measure-side-table">
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">P</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_active_total', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">kW</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">S</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_apparent_total', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">V</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'voltage_l1', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">V</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">I</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'current_total', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit">A</div>
                                </div>
                                <div className="measure-side-rows">
                                    <div className="measure-side-cell">PF</div>
                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_factor', 2)}</div>
                                    <div className="measure-side-cell measure-side-cell-unit"></div>
                                </div>
                            </div>
                        </div>
                        {
                            draw_solar_meter_total(data_metersolar, data_metersolar_total)
                        }
                        {
                            data_metersolar ?
                                data_metersolar.map((meter, index) => (
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12" key={'MeterSolar-' + meter.meter_id}>
                                        <div>
                                            <hr className="mt-1 mb-2" />
                                            <h6 className="mb-0">{meter.meter_id_text} {getDeviceStatusDirect(meter)} {getCT_Alert(meter)}</h6>
                                            <h6 className="mb-0 h6">{meter.meter_area_name}</h6>
                                            <h6 className="mb-0 h6">S/N: {meter.serial_no}</h6>
                                            <div className="measure-side-table">
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell">P</div>
                                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_active_total', 2)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit">kW</div>
                                                </div>
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell">S</div>
                                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_apparent_total', 2)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                                                </div>
                                                {
                                                    meter.measure_side === "HV" ?
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">V</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'voltage_l12', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">V</div>
                                                        </div>
                                                        :
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">V</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'voltage_l1', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">V</div>
                                                        </div>
                                                }
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell">I</div>
                                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'current_total', 2)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit">A</div>
                                                </div>
                                                <div className="measure-side-rows">
                                                    <div className="measure-side-cell">PF</div>
                                                    <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_factor', 2)}</div>
                                                    <div className="measure-side-cell measure-side-cell-unit"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                null
                        }
                    </div>
                </aside>

                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/overview"
                            element={
                                <MeasurementOverview
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_chart={props.data_chart}
                                    data_calculation={data_calculation}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementOverview>} />
                        <Route path="/pvlaout"
                            element={
                                <MeasurementPVLayout
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_uioption={data_uioption}
                                    data_inverter={data_inverter}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementPVLayout>} />
                        <Route path="/inverters"
                            element={
                                <MeasurementInverters
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_inverter={data_inverter}
                                    data_uioption={data_uioption}
                                    data_status_indicator={data_status_indicator}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementInverters>} />
                        <Route path="/metering"
                            element={
                                <MeasurementMetering
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_metergrid={data_metergrid}
                                    data_metersolar={data_metersolar}
                                    data_chart={props.data_chart}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementMetering>} />
                        <Route path="/systemperformance"
                            element={
                                <MeasurementPerformance
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_chart={props.data_chart}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementPerformance>} />
                        <Route path="/indicator"
                            element={
                                <MeasurementIndicator
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_status_indicator={data_status_indicator}
                                    data_status_common={data_status_common}
                                    local_data_ok={props.local_data_ok}
                                    local_api_state={props.local_api_state}
                                    data_uioption={data_uioption}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementIndicator>} />
                        <Route path="/environment"
                            element={
                                <MeasurementEnvironment
                                    systemtime={props.data_systemdatetime}
                                    server_update={props.server_update}
                                    permitdata={props.permitdata}
                                    data_calculation={data_calculation}
                                    data_environment={data_environment}
                                    data_metergrid={data_metergrid}
                                    data_metersolar={data_metersolar}
                                    data_uioption={data_uioption}
                                    callback_backcenter={() => { props.callback_backcenter() }}
                                ></MeasurementEnvironment>} />
                    </Routes>

                    <div className="modal meya-overide " style={{ display: modal_sampling ? "block" : "none" }}>
                        <div className="modal-dialog modal-md modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header py-2">
                                    <h5 className="modal-title">Irradiation Sub-Sampling View</h5>
                                    <i className="fe-x modal-close" onClick={() => { setModal_sampling(false) }}></i>
                                </div>
                                <div className="modal-body">
                                    <div className="measure-side-table font-sarabun">
                                        <div className="measure-side-rows bg-gray">
                                            <div className="measure-side-cell border-bottom">Timestamp</div>
                                            <div className="measure-side-cell border-bottom font-right px-2">{getTagString(data_environment, 'irr1_name')}</div>
                                            <div className={"measure-side-cell border-bottom font-right px-2" + check_irr2()}>{getTagString(data_environment, 'irr2_name')}</div>
                                            <div className="measure-side-cell border-bottom measure-side-cell-unit">Unit</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 0, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 0, "state_irr1")}>{readsampling_value(data_environment, 0, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 0, "state_irr2")}>{readsampling_value(data_environment, 0, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 1, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 1, "state_irr1")}>{readsampling_value(data_environment, 1, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 1, "state_irr2")}>{readsampling_value(data_environment, 1, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 2, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 2, "state_irr1")}>{readsampling_value(data_environment, 2, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 2, "state_irr2")}>{readsampling_value(data_environment, 2, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 3, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 3, "state_irr1")}>{readsampling_value(data_environment, 3, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 3, "state_irr2")}>{readsampling_value(data_environment, 3, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 4, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 4, "state_irr1")}>{readsampling_value(data_environment, 4, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 4, "state_irr2")}>{readsampling_value(data_environment, 4, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 5, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 5, "state_irr1")}>{readsampling_value(data_environment, 5, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 5, "state_irr2")}>{readsampling_value(data_environment, 5, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 6, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 6, "state_irr1")}>{readsampling_value(data_environment, 6, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 6, "state_irr2")}>{readsampling_value(data_environment, 6, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 7, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 7, "state_irr1")}>{readsampling_value(data_environment, 7, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 7, "state_irr2")}>{readsampling_value(data_environment, 7, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">{readsampling_timestamp(data_environment, 8, 'timestamp')}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 8, "state_irr1")}>{readsampling_value(data_environment, 8, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell font-right px-2" + check_irr_sample_color(data_environment, 8, "state_irr2")}>{readsampling_value(data_environment, 8, 'irr2', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell border-bottom">{readsampling_timestamp(data_environment, 9, 'timestamp')}</div>
                                            <div className={"measure-side-cell border-bottom font-right px-2" + check_irr_sample_color(data_environment, 9, "state_irr1")}>{readsampling_value(data_environment, 9, 'irr1', 2)}</div>
                                            <div className={"measure-side-cell border-bottom font-right px-2" + check_irr_sample_color(data_environment, 9, "state_irr2")}>{readsampling_value(data_environment, 9, 'irr2', 2)}</div>
                                            <div className="measure-side-cell border-bottom measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className={"measure-side-rows" + check_irr2()}>
                                            <div className="measure-side-cell border-bottom">Pre-Average</div>
                                            <div className="measure-side-cell border-bottom font-right px-2">{ReadDatatags(data_environment, 'irr1_avg', 2)}</div>
                                            <div className="measure-side-cell border-bottom font-right px-2">{ReadDatatags(data_environment, 'irr2_avg', 2)}</div>
                                            <div className="measure-side-cell border-bottom measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell border-bottom">Total Average</div>
                                            <div className={"measure-side-cell border-bottom font-right px-2" + check_irr2()}></div>
                                            <div className="measure-side-cell border-bottom font-right px-2">{ReadDatatags(data_environment, 'irr_avg_total', 2)}</div>
                                            <div className="measure-side-cell border-bottom measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer py-1">
                                    <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_sampling(false) }}><i className="fe-x"></i> Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        modal_pr30d ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header py-2">
                                                <h5 className="modal-title">Performace Ratio 30 Days History View</h5>
                                                <i className="fe-x modal-close" onClick={() => { setModal_pr30d(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <div className="measure-side-table">
                                                    <div className="measure-side-rows bg-gray">
                                                        <div className="measure-side-cell border-bottom px-1">#</div>
                                                        <div className="measure-side-cell border-bottom">Date</div>
                                                        <div className="measure-side-cell border-bottom font-right px-2">Irradiation (kWh/m<sup>2</sup>)</div>
                                                        <div className="measure-side-cell border-bottom font-right px-2" >AC Energy (kWh)</div>
                                                        <div className="measure-side-cell border-bottom font-right px-2" >PR Daily (%)</div>
                                                    </div>
                                                    {
                                                        data_calculation.pr30d_table?.map((pr, index) => (
                                                            <div className={"measure-side-rows font-sarabun " + (pr.datetimestamp === "Total" ? "font_sum_pr" : "")} key={pr.datetimestamp}>
                                                                <div className="measure-side-cell border-bottom px-1">{pr.datetimestamp === "Total" ? "" : index + 1}</div>
                                                                <div className="measure-side-cell border-bottom">{pr.datetimestamp} {index === 0 && pr.datetimestamp !== "Total" ? <span className='perfected-days'> Last Perfected Day</span> : ""}</div>
                                                                <div className="measure-side-cell border-bottom font-right px-2" >{data_calculation.pr30d_table.length > 1 ? pr.total_irr.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</div>
                                                                <div className="measure-side-cell border-bottom font-right px-2">{data_calculation.pr30d_table.length > 1 ? pr.total_energy.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : "-"}</div>
                                                                <div className="measure-side-cell border-bottom font-right px-2">{data_calculation.pr30d_table.length > 1 ? pr.total_pr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}</div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            <div className="modal-footer py-1">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_pr30d(false) }}><i className="fe-x"></i> Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </section>
    )
}
export default Measurement